export default __webpack_public_path__ + "static/media/tiger2.3f27f787.png";